/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityChangeType } from './EntityChangeType';
import {
    EntityChangeTypeFromJSON,
    EntityChangeTypeFromJSONTyped,
    EntityChangeTypeToJSON,
} from './EntityChangeType';
import type { EntityWithHistoryType } from './EntityWithHistoryType';
import {
    EntityWithHistoryTypeFromJSON,
    EntityWithHistoryTypeFromJSONTyped,
    EntityWithHistoryTypeToJSON,
} from './EntityWithHistoryType';
import type { HistoryDtoHiddenEntityType } from './HistoryDtoHiddenEntityType';
import {
    HistoryDtoHiddenEntityTypeFromJSON,
    HistoryDtoHiddenEntityTypeFromJSONTyped,
    HistoryDtoHiddenEntityTypeToJSON,
} from './HistoryDtoHiddenEntityType';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { PropertyChangeSectionDto } from './PropertyChangeSectionDto';
import {
    PropertyChangeSectionDtoFromJSON,
    PropertyChangeSectionDtoFromJSONTyped,
    PropertyChangeSectionDtoToJSON,
} from './PropertyChangeSectionDto';

/**
 * 
 * @export
 * @interface HistoryDto
 */
export interface HistoryDto {
    /**
     * 
     * @type {EntityChangeType}
     * @memberof HistoryDto
     */
    changeType?: EntityChangeType;
    /**
     * 
     * @type {EntityWithHistoryType}
     * @memberof HistoryDto
     */
    entityType?: EntityWithHistoryType;
    /**
     * 
     * @type {HistoryDtoHiddenEntityType}
     * @memberof HistoryDto
     */
    hiddenEntityType?: HistoryDtoHiddenEntityType | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryDto
     */
    changeTime?: string;
    /**
     * 
     * @type {number}
     * @memberof HistoryDto
     */
    userId?: number | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof HistoryDto
     */
    user?: HistoryDtoUser | null;
    /**
     * 
     * @type {Array<PropertyChangeSectionDto>}
     * @memberof HistoryDto
     */
    propertyChangeSections?: Array<PropertyChangeSectionDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryDto
     */
    summary?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryDto
     */
    $type?: HistoryDtoTypeEnum;
}


/**
 * @export
 */
export const HistoryDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedEntityHistoryHistoryDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.EntityHistory.HistoryDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type HistoryDtoTypeEnum = typeof HistoryDtoTypeEnum[keyof typeof HistoryDtoTypeEnum];


/**
 * Check if a given object implements the HistoryDto interface.
 */
export function instanceOfHistoryDto(value?: unknown): value is HistoryDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(HistoryDtoTypeEnum)[0];
}

export function HistoryDtoFromJSON(json: any): HistoryDto {
    return HistoryDtoFromJSONTyped(json, false);
}

export function HistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'changeType': !exists(json, 'changeType') ? undefined : EntityChangeTypeFromJSON(json['changeType']),
        'entityType': !exists(json, 'entityType') ? undefined : EntityWithHistoryTypeFromJSON(json['entityType']),
        'hiddenEntityType': !exists(json, 'hiddenEntityType') ? undefined : HistoryDtoHiddenEntityTypeFromJSON(json['hiddenEntityType']),
        'changeTime': !exists(json, 'changeTime') ? undefined : json['changeTime'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'user': !exists(json, 'user') ? undefined : HistoryDtoUserFromJSON(json['user']),
        'propertyChangeSections': !exists(json, 'propertyChangeSections') ? undefined : (json['propertyChangeSections'] === null ? null : (json['propertyChangeSections'] as Array<any>).map(PropertyChangeSectionDtoFromJSON)),
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function HistoryDtoToJSON(value?: HistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'changeType': EntityChangeTypeToJSON(value.changeType),
        'entityType': EntityWithHistoryTypeToJSON(value.entityType),
        'hiddenEntityType': HistoryDtoHiddenEntityTypeToJSON(value.hiddenEntityType),
        'changeTime': value.changeTime,
        'userId': value.userId,
        'user': HistoryDtoUserToJSON(value.user),
        'propertyChangeSections': value.propertyChangeSections === undefined ? undefined : (value.propertyChangeSections === null ? null : (value.propertyChangeSections as Array<any>).map(PropertyChangeSectionDtoToJSON)),
        'summary': value.summary,
        '$type': value.$type,
    });
}

